import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useRouteMatch } from 'react-router';
import { CService } from 'services/class.base.service';
import { clearTempPage } from './useLocalStorage';

export default 
  function useStateByRequest<T = undefined>(service:CService, defaultValue:T | (()=>T), params:any):
  [T, React.Dispatch<React.SetStateAction<T>>, boolean, boolean];
export default 
  function useStateByRequest<T = undefined>(service:CService, defaultValue:T | (()=>T), params?:any):
  [T, React.Dispatch<React.SetStateAction<T>>, boolean, boolean];
export default 
  function useStateByRequest<T = undefined>(service:CService, defaultValue?:T | (()=>T), params?:any):
  [T, React.Dispatch<React.SetStateAction<T>>, boolean, boolean];
export default 
  function useStateByRequest<T = any>(service:CService, defaultValue?:any, params?:any)
{
  let match = useRouteMatch<any>();
  const [ data, setData ] = useState<T>(defaultValue);
  const [ block, setBlock ] = useState<boolean>(false);
  const [ paramsIternal ] = useState(params);
  const [ compareData, setCompareData ] = useState<T>(defaultValue);

  const getData = useCallback((id:number)=>{
    service.show<T>(id,paramsIternal).then((data)=>{
      setData(data);
      setCompareData(data);
    });
  },[paramsIternal,service]);

  const hasModifiedData = useMemo(()=>{
    function hasChange(data1:any, data2:any){
      let _return = false;
      Object.keys(data1).forEach(name=>{
        let v1 = data1[name];
        let v2 = data2[name];
        if(v1 instanceof Array && v2 instanceof Array){
          if(v1.length === v2.length){
            if(v1.length>0){
              for (let i = 0; i < v1.length; i++) {
                if(hasChange(data1[name][i],data2[name][i])){
                  _return = true;
                }
              }
            }
          } else {
            _return = true;
          }
        } else if(v1 instanceof Object && v2 instanceof Object){
          if(hasChange(v1,v2)){
            _return = true;
          }
        } else {
          if(v1 !== v2)
          _return = true;
        }
      });
  
      return _return;
    }

    return hasChange(data, compareData);
  },[data,compareData]);

  useEffect(() => {
    if(match.params && match.params.id){
      getData(match.params.id);
    }
    if(match.url.indexOf("show") !== -1){
      setBlock(true);
    }
    let location = window.location.pathname;
    return ()=>{
      clearTempPage(location);
    }
  },[match, getData]);

  return [ data, setData, block, hasModifiedData];
}